'use strict';

angular.module('mobile-apps')
	.directive('imageWithOverlay',[
			'EntryMain',
			'$compile',
			'$window',
			'TagMain',
			'$timeout',
			function(
				EntryMain,
				$compile,
				$window,
				TagMain,
				$timeout
			) {
				return {
					scope:
					{
						imagePath : '@', // The path of the image to display
						clickCallback : '=', // Callback to call when clicked on image
						overlays : '=', // Overlays to display on the image
						imageScale: '@', // Defines how the image gets displayed (optional):
						// - "-1": Original image resolution
						// - ">0<-1": Image gets displayed smaller as with "-1"
						// - "<-1": Image gets displayed larger as with "-1"
						// - ">1": Image gets displayed larger as with "1"
						// -  "1": Image gets displayed as large as possible without
						//         displaying it larger than it is
						// - ">0<1": Image gets displayed smaller as with "1"
						// - ">1": Image gets displayed larger as with "1",
					},
					templateUrl: 'modules/mobile-apps/views/image-with-overlay.client.directive.html',

					link: function (scope, elem, attrs) {

						scope.stringPositions = [];
						scope.displayHeight = 0;
						scope.displayWidth = 0;
						scope.scaleFactor = 1;
						scope._checkRunning = false;
						scope.loadedStatus = false;
						scope.overallScale = 1;
						scope.visibleIndex = undefined;


						var image = elem[0].querySelector('.overlay-image-image');
						var overlayImageWrapper = elem[0].querySelector('.overlay-image-wrapper');
						var overlayImageStringWrappers = elem[0].querySelectorAll('.overlay-image-string-wrapper');


						/**
						 * Returns special style to scale image according to current
						 * overallScale
						 */
						scope.getImageStyles = function() {
							var returnStyles = {};

							if (scope.overallScale !== 1) {
								// Overwrite the automatic scaling that happens via css
								returnStyles['max-height'] = 'none';
								returnStyles['max-width'] = 'none';

								if (scope.overallScale < 0) {
									// Image original resolution

									// If the image is larger in any direction
									// we change the margin from "auto" to "initial"
									// else the whole image would not be visible.
									if (image.naturalWidth > overlayImageWrapper.offsetWidth) {
										returnStyles['margin-right'] = 'initial';
										returnStyles['margin-left'] = 'initial';
									}
									if (image.naturalHeight > overlayImageWrapper.offsetHeight) {
										returnStyles['margin-top'] = 'initial';
										returnStyles['margin-bottom'] = 'initial';
									}

									// Apply scale on original resolution. Only if
									// set to -1 it displays it exactly in the original
									// resolution else it scales it accordingly.
									var absOverallScale = Math.abs(scope.overallScale);
									returnStyles['width'] = image.naturalWidth * absOverallScale;
									returnStyles['height'] = image.naturalHeight * absOverallScale;
								} else {
									// Scale image
									var maxResolution = {
										width: overlayImageWrapper.offsetWidth,
										height: overlayImageWrapper.offsetHeight
									};

									var imageData = {
										width: image.naturalWidth,
										height: image.naturalHeight
									};

									// Calculate the display resolution of the image to
									// fit in the allowed space
									var displayImageResolution = TagMain._calculateFixBoxDimensions(imageData, maxResolution);

									returnStyles['width'] = displayImageResolution.width * scope.overallScale;
									returnStyles['height'] = displayImageResolution.height * scope.overallScale;
								}
							}

							return returnStyles;
						};


						scope.buttonClick = function(buttonData, key, event) {
							if (buttonData.hasOwnProperty('onClick')) {
								buttonData.onClick(key, event);
							}
						};


						/**
						 * Returns object with css properties to display the string
						 * at the correct location
						 */
						function getStringPositionStyle(stringPosition) {
							// Check first if any valid data is available
							if (stringPosition.x === -1 || stringPosition.y === -1) {
								return undefined;
							}

							// If the strings would not be visible no need to display them
							if (parseInt(stringPosition.x*scope.scaleFactor) > scope.displayWidth || parseInt(stringPosition.y*scope.scaleFactor) > scope.displayHeight) {
								return undefined;
							}

							// Set the values with scale factors applied to display
							// strings correctly for current image size
							var returnData = {};
							returnData.top = parseInt(stringPosition.y * scope.scaleFactor) + 'px';
							returnData.left = parseInt(stringPosition.x * scope.scaleFactor) + 'px';
							returnData.height = parseInt(stringPosition.height * scope.scaleFactor) + 'px';
							returnData.width = parseInt(stringPosition.width * scope.scaleFactor) + 'px';

							return returnData;
						};


						/**
						 * Displays and hides the string overlay
						 */
						scope.changeStringVisibility = function (show, index, $event) {
							if (show === true) {
								scope.visibleIndex = index;
							} else {
								scope.visibleIndex = undefined;
							}

							var buttonElement = elem[0].querySelector('.overlay-image-buttons-' + index);
							if (buttonElement) {
								buttonElement.style.display = show?'block':'none';
							}
						};


						/**
						 * Sets the position of the string-wrapper according to the
						 * position of the image
						 */
						function setStringWrapperPosition() {
							overlayImageStringWrappers.forEach(function(overlayImageStringWrapper) {
								overlayImageStringWrapper.style.width = image.offsetWidth + "px";
								overlayImageStringWrapper.style.height = image.offsetHeight + "px";
								overlayImageStringWrapper.style.top = image.offsetTop + "px";
								overlayImageStringWrapper.style.left = image.offsetLeft + "px";
							});
						};


						/**
						 * Sets the array with the string positions to be displayed
						 */
						function setStringPositions() {

							// Add stringPositions if we have any to display them
							// on the images
							scope.stringPositions.length = 0;
							scope.isBlank = scope.isBlankScreenshot;


							if (scope.overlays && scope.overlays.length) {
								// Go through them one at a time and set the calculated
								// location
								scope.overlays.forEach(function(overlayData) {

									// Get the styles which contains mainly the location
									var stringStyle = getStringPositionStyle(overlayData.position);
									if (stringStyle === undefined) {
										// If we did not get anything back the data
										// is not valid
										return;
									}

									var onClickFunction = function() {};
									if (overlayData.hasOwnProperty('onClick')) {
										onClickFunction = overlayData.onClick;
									}

									var addOverlayData = {
										key: overlayData.key,
										isBlank: overlayData.isBlank,
										style: stringStyle,
										textStyle: overlayData.css,
										class: overlayData.class,
										onClick: onClickFunction,
										scale: scope.scaleFactor
									};

									if(addOverlayData.isBlank) {
										var entryValue = Object.values(EntryMain.allValues).find(function(entry){return entry.key === overlayData.key; })
										addOverlayData.text = entryValue.draft || entryValue.value || entryValue.sourceValue || entryValue.baseValue;
										addOverlayData.text = addOverlayData.text.replace(/(?:\r\n|\r|\n)/g, '<br>');

										// adjust font size of the rendered text
										var matchFontSize = addOverlayData.textStyle.match(/font-size:\s*(.*?);/);
										if(matchFontSize && matchFontSize.length) {
											var fontSize = parseInt(matchFontSize[1]);
											addOverlayData.textStyle = addOverlayData.textStyle.replace(/font-size:\s*(.*?);/, 'font-size: ' + (fontSize * scope.scaleFactor).toFixed(0) + 'px;');
										}
									}

									if (overlayData.hasOwnProperty('buttons')) {
										addOverlayData.buttons = overlayData.buttons;
									}

									// We got valid data so add the string to be displayed
									scope.stringPositions.push(addOverlayData);
								});


								setStringWrapperPosition();
							}

						};


						/**
						 * Calculates the scale factor to display strings correctly
						 */
						function calculateScaleFactor() {
							scope.displayHeight = image.clientHeight;
							scope.displayWidth = image.clientWidth;
							if (scope.displayHeight > 0 && scope.displayWidth > 0) {
								// Does not matter if height or width gets used, the
								// factor will be the same
								//scope.scaleFactor = scope.displayHeight / scope.data.metaData.height;
								scope.scaleFactor = scope.displayHeight / image.naturalHeight;
							}
						}


						/**
						 * Returns the current resolution the image combined
						 * with the window resolution
						 */
						var getImageAndWindowResolution = function() {
							return image.clientWidth + image.clientHeight + $window.innerWidth + $window.innerHeight;
						};

						// Saves the resolution the image had in the prev.
						// checkForResolutionChange run
						scope._prevImageResolution = getImageAndWindowResolution();
						scope._resolutionChangeCallbackRunning = false;
						scope._resolutionNotChangedCounter = 0;


						/**
						 * Function that updating string position till the resolution
						 * of the image and the window did not change from prev.
						 * runs for 5x in a row.
						 */
						var checkForResolutionChange = function(isCallback) {

							if (!isCallback && scope._resolutionChangeCallbackRunning === true) {
								// We do not want to have multiple ones running at the
								// same time so exit if runs already
								return;
							}

							scope._resolutionChangeCallbackRunning = true;
							var currentResolution = getImageAndWindowResolution();

							if (scope._prevImageResolution !== currentResolution) {
								// Resolution changed so check again
								scope._resolutionNotChangedCounter = 0;
								scope._prevImageResolution = currentResolution;
								$timeout(function() {
									checkForResolutionChange(true);
								}, 25);
							} else if(scope._resolutionNotChangedCounter < 5) {
								// Resolution did not change but we did not yet
								// check often enough
								scope._resolutionNotChangedCounter++;
								$timeout(function() {
									checkForResolutionChange(true);
								}, scope._resolutionNotChangedCounter*25);
							} else {
								// Resolution did not change for a long enough time
								// so we can stop
								scope._resolutionNotChangedCounter = 0;
								scope._resolutionChangeCallbackRunning = false;
							}
							scope.checkReady();
						};


						/**
						 * Checks if all the needed variables got set to valid values
						 * and initializes the stringPositions once done
						 */
						scope.checkReady = function() {
							if (scope._checkRunning === true) {
								return;
							}

							calculateScaleFactor();

							// Only run if we have valid values
							if (scope.displayHeight !== 0 && scope.displayWidth !== 0) {
								scope._checkRunning = true;
								$timeout(function() {
									// Calculate the scale factors again because they
									// could have changed since the timeout started
									calculateScaleFactor();
									setStringPositions();
									scope._checkRunning = false;
								}, 25);
							}
						};


						// Keep an eye on the image that we can display it animation
						// when it changes and it has to load it first.
						scope.$watch('imagePath', function(imagePath) {
							if (imagePath) {
								scope.loadedStatus = false;
								setStringWrapperPosition();
								checkForResolutionChange();
							}
						});


						// Keep an eye on the data that we can update the strings
						// whenever it changes
						scope.$watch(function() { return scope.overlays; }, function(newValue) {
							if (newValue) {
								checkForResolutionChange();
							}
						}, true);


						scope.$watch(function() {return scope.imageScale; }, function() {
							if (scope.imageScale) {
								var scale = parseFloat(scope.imageScale);
								if (!isNaN(scale)) {
									scope.overallScale = scale;
									// Update the displayed strings
									scope.checkReady();						}
							}
						});


						image.addEventListener('load', function() {
							scope.loadedStatus = true;
							$timeout(function() {
								scope.checkReady();
							}, 200);
						}, false);


						// Whenever the resolution of the window changes we
						// check if the resolution of the image changed because
						// then also the positions of the displayed strings have
						// to get updated.
						angular.element($window).bind('resize', function(a){
							if (scope.overlays && scope.overlays.length) {
								// Only update when there are overlays to display
								checkForResolutionChange();
							}
						});


						/**
						 * If an optional callback got defined for clicking on
						 * image it gets called
						 */
						scope.imageClicked = function($event) {
							$event.stopPropagation();
							if (scope.clickCallback) {
								scope.clickCallback();
							}
						};


						scope.$on('liveEditEntryDraft', function (event, entry) {
							var overlayData = scope.overlays.find(function(overlay){ return overlay.key === entry.key; });
							if(!overlayData) return;

							overlayData.text = entry.draft;
						});

					}
				};
			}
		]
	);
